import { createSelector } from "@reduxjs/toolkit"
import type { UseQueryResult } from "@tanstack/react-query"
import type { Address } from "viem"
import type { GetPerspectiveData } from "../query"
import { selectQueryStatus } from "../utils"

export const selectPerspectiveVaults = (perspective: GetPerspectiveData) =>
  Array.isArray(perspective.vaults) ? perspective.vaults : []

export const combinePerspectiveVaults = createSelector(
  (results: UseQueryResult<Address[]>[]) => results,
  (results: UseQueryResult<Address[]>[]) => selectQueryStatus(results),
  (results, status) => {
    const data = status.isSuccess
      ? results.flatMap((result) => result.data || [])
      : undefined

    return { ...status, data }
  },
)
